<div class="badm">
  <!-- El tablero de una campaña reemplaza la lista: no es un panel al costado
       porque la tabla de reclamos necesita todo el ancho para ser legible. -->
  <app-campana-tablero
    *ngIf="campanaAbierta"
    [campana]="campanaAbierta"
    (volver)="volverALista()"
  ></app-campana-tablero>

  <ng-container *ngIf="!campanaAbierta">
    <header class="badm-header">
      <h1>Bonos</h1>

      <span class="badm-switch" [class.on]="config.activo" *ngIf="config">
        {{ config.activo ? 'Módulo encendido' : 'Módulo apagado' }}
      </span>

      <button class="badm-config" (click)="abrirConfig()">Configurar</button>
      <button class="badm-nueva" (click)="abrirNueva()">Nueva campaña</button>
    </header>

    <!-- Los tres frenos que hoy están puestos. Un operador que no los ve
         concluye que el bono no funciona, y tiene razón sin saber por qué. -->
    <p class="badm-nota" *ngIf="moduloApagado">
      <b>El módulo está apagado.</b> Se pueden armar campañas y activarlas, pero
      <b>ningún reclamo se acepta</b> mientras <code>BONOS_ACTIVO</code> esté en
      <code>NO</code>. Es el interruptor general: no depende del estado de cada campaña.
    </p>

    <p class="badm-nota" *ngIf="monedasFrenadas.length">
      <b>Techo del mes en 0</b> para {{ monedasFrenadas.join(', ') }}: en esas monedas
      no se acredita nada hasta que Finanzas cargue el tope. Es a propósito &mdash; un
      control de gasto ausente frena en vez de dejar pasar.
    </p>

    <p class="badm-nota dim" *ngIf="monedasConDobleControlTotal.length">
      Umbral de doble control en <b>0</b> para
      {{ monedasConDobleControlTotal.join(', ') }}: <b>toda campa&ntilde;a en esas
      monedas necesita un segundo operador</b> para activarse, sin importar el monto.
      Quien la crea no la activa. Ojo con la lectura &mdash; ac&aacute; el 0 no
      significa &laquo;control apagado&raquo;, significa &laquo;control siempre&raquo;.
    </p>

    <div class="badm-cargando" *ngIf="cargando">Cargando&hellip;</div>
    <div class="badm-error" *ngIf="error">{{ error }}</div>

    <ng-container *ngIf="!cargando && !error">
      <!-- Pestañas -->
      <div class="badm-tabs">
        <button [class.on]="vista === 'campanas'" (click)="verCampanas()">
          Campa&ntilde;as
        </button>
        <button [class.on]="vista === 'gasto'" (click)="verGasto()">Gasto</button>
        <button [class.on]="vista === 'kpi'" (click)="verKpi()">KPI</button>
      </div>

      <!-- ------------------------------------------------------ campañas -->
      <div *ngIf="vista === 'campanas'">
        <div class="badm-estados">
          <button [class.on]="!filtroEstado" (click)="filtroEstado = ''">
            Todas <b>{{ campanas.length }}</b>
          </button>
          <button [class.on]="filtroEstado === 'BORRADOR'" (click)="filtroEstado = 'BORRADOR'">
            Borradores <b>{{ contar('BORRADOR') }}</b>
          </button>
          <button [class.on]="filtroEstado === 'ACTIVA'" (click)="filtroEstado = 'ACTIVA'">
            Activas <b>{{ contar('ACTIVA') }}</b>
          </button>
          <button [class.on]="filtroEstado === 'PAUSADA'" (click)="filtroEstado = 'PAUSADA'">
            Pausadas <b>{{ contar('PAUSADA') }}</b>
          </button>
          <button [class.on]="filtroEstado === 'CERRADA'" (click)="filtroEstado = 'CERRADA'">
            Cerradas <b>{{ contar('CERRADA') }}</b>
          </button>
        </div>

        <p class="badm-vacio" *ngIf="!visibles.length && campanas.length">
          Ninguna campa&ntilde;a en ese estado.
        </p>
        <p class="badm-vacio" *ngIf="!campanas.length">
          Todav&iacute;a no hay campa&ntilde;as. La primera se crea con
          <b>Nueva campa&ntilde;a</b> y nace en borrador.
        </p>

        <div class="badm-tabla-wrap" *ngIf="visibles.length">
          <table>
            <thead>
              <tr>
                <th>Campa&ntilde;a</th>
                <th>A qui&eacute;n</th>
                <th>Bono</th>
                <th>Cupo</th>
                <th>Bolsa</th>
                <th>Vigencia</th>
                <th class="acc">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let c of visibles"
                [class.cerrada]="c.estado === 'CERRADA'"
                [class.pausada]="c.estado === 'PAUSADA'"
              >
                <td>
                  <a class="badm-link" (click)="abrir(c)">{{ c.nombre }}</a>
                  <span class="mono codigo">{{ c.codigo }}</span>
                  <span class="pill mini" [ngClass]="c.estado.toLowerCase()">
                    {{ c.estado.toLowerCase() }}
                  </span>
                  <span class="pill mini bad" *ngIf="c.pausadaMotivo === 'VELOCIDAD'">
                    la fren&oacute; el ritmo
                  </span>
                  <span class="pill mini warn" *ngIf="vencida(c)">vigencia terminada</span>
                  <span class="pill mini" *ngIf="porEmpezar(c)">a&uacute;n no arranca</span>
                </td>

                <td>
                  {{ c.alcanceCodigo }} &middot; {{ publicoTexto(c.alcancePublico) }}
                  <span class="dim small" *ngIf="c.alcancePublico === 'INACTIVO' && c.inactivoDias">
                    sin enviar hace {{ c.inactivoDias }} d&iacute;as
                  </span>
                </td>

                <td>
                  <strong>{{ legible(c.monto) }}</strong> <span class="mono">{{ c.moneda }}</span>
                  <span class="dim small">{{ condicionTexto(c.condicionAcreditacion) }}</span>
                  <span class="pill mini bad" *ngIf="sinCamino(c)">
                    sin camino de pago
                  </span>
                </td>

                <td>
                  {{ c.unidadesUsadas }} / {{ c.unidadesTotal }}
                  <span class="badm-barra">
                    <i [style.width.%]="avance(c)"></i>
                  </span>
                </td>

                <td>
                  <strong>{{ legible(c.comprometido) }}</strong>
                  <span class="dim small">comprometido de {{ legible(c.presupuesto) }}</span>
                  <span class="dim small">pagado {{ legible(c.pagado) }}</span>
                </td>

                <td class="dim">
                  {{ c.vigenciaDesde | date: 'dd/MM/yy' }}<br />
                  {{ c.vigenciaHasta | date: 'dd/MM/yy' }}
                </td>

                <td class="acc">
                  <!-- Explícito y primero: quién reclamó es lo que un operador
                       viene a mirar todos los días. Estaba sólo detrás del
                       nombre de la campaña, y lo que no se encuentra no existe. -->
                  <button class="badm-b ver" (click)="abrir(c)">Ver reclamos</button>
                  <button
                    class="badm-b activar"
                    *ngIf="puedeActivar(c)"
                    [disabled]="moviendo === c.bonoCampanaId"
                    (click)="activar(c)"
                  >
                    Activar
                  </button>
                  <button
                    class="badm-b"
                    *ngIf="puedePausar(c)"
                    [disabled]="moviendo === c.bonoCampanaId"
                    (click)="pausar(c)"
                  >
                    Pausar
                  </button>
                  <button
                    class="badm-b activar"
                    *ngIf="puedeReanudar(c)"
                    [disabled]="moviendo === c.bonoCampanaId"
                    (click)="reanudar(c)"
                  >
                    Reanudar
                  </button>
                  <button
                    class="badm-b cerrar"
                    *ngIf="puedeCerrar(c)"
                    [disabled]="moviendo === c.bonoCampanaId"
                    (click)="cerrar(c)"
                  >
                    Cerrar
                  </button>

                  <span
                    class="badm-firma"
                    *ngIf="necesitaSegundaFirma(c) && (puedeActivar(c) || puedeReanudar(c))"
                    title="Quien crea la campaña no la activa. Se compara por documento, no sólo por cuenta."
                  >
                    necesita 2&deg; firma
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- --------------------------------------------------------- gasto -->
      <div *ngIf="vista === 'gasto'">
        <p class="badm-nota dim">
          <b>Comprometido</b> y <b>pagado</b> son dos cosas distintas para el cierre: una
          reserva viva es un compromiso pendiente, no gasto. Va por moneda y
          <b>sin consolidar en d&oacute;lares</b> &mdash; el consolidado se mueve con la
          tasa, as&iacute; que el mismo cierre dar&iacute;a dos n&uacute;meros distintos
          seg&uacute;n el d&iacute;a en que se corra.
        </p>

        <button class="badm-b" (click)="refrescarReportes()">Actualizar</button>

        <p class="badm-vacio" *ngIf="cargandoReporte">Calculando&hellip;</p>
        <p class="badm-vacio" *ngIf="!cargandoReporte && !gasto.length">
          Todav&iacute;a no hay reclamos, as&iacute; que no hay gasto.
        </p>

        <div class="badm-tabla-wrap" *ngIf="!cargandoReporte && gasto.length">
          <table>
            <thead>
              <tr>
                <th>Moneda</th>
                <th>Campa&ntilde;as</th>
                <th>Comprometido</th>
                <th>Pagado</th>
                <th>Pendiente</th>
                <th>Bonos</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let g of gasto">
                <td><span class="mono">{{ g.moneda }}</span></td>
                <td>{{ g.campanas }}</td>
                <td><strong>{{ legible(g.comprometido) }}</strong></td>
                <td>{{ legible(g.pagado) }}</td>
                <td class="warn-txt">{{ legible(g.pendiente) }}</td>
                <td class="dim small">
                  {{ g.bonosAcreditados }} acreditados &middot;
                  {{ g.bonosRetenidos }} retenidos
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ----------------------------------------------------------- KPI -->
      <div *ngIf="vista === 'kpi'">
        <p class="badm-nota dim">
          La tasa viene vac&iacute;a &mdash;no en 0&mdash; cuando la campa&ntilde;a
          todav&iacute;a no acredit&oacute; nada: una campa&ntilde;a sin pagos no tiene
          una tasa del 0%, no tiene tasa. Mostrar 0% invita a concluir que
          funcion&oacute; mal cuando todav&iacute;a no funcion&oacute; nada.
        </p>

        <button class="badm-b" (click)="refrescarReportes()">Actualizar</button>

        <p class="badm-vacio" *ngIf="cargandoReporte">Calculando&hellip;</p>
        <p class="badm-vacio" *ngIf="!cargandoReporte && !kpis.length">
          Ninguna campa&ntilde;a tuvo reclamos todav&iacute;a.
        </p>

        <div class="badm-tabla-wrap" *ngIf="!cargandoReporte && kpis.length">
          <table>
            <thead>
              <tr>
                <th>Campa&ntilde;a</th>
                <th>Reclamaron</th>
                <th>Se les acredit&oacute;</th>
                <th>Enviaron despu&eacute;s</th>
                <th>Tasa</th>
                <th>Costo por 1&ordm; env&iacute;o</th>
                <th>Reactivados</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of kpis">
                <td>
                  <span class="mono codigo">{{ k.codigo }}</span>
                  <span class="dim small">{{ k.alcance }} &middot; {{ publicoTexto(k.publico) }}</span>
                </td>
                <td>{{ k.reclamos }}</td>
                <td>{{ k.acreditados }}</td>
                <td>{{ k.activados }}</td>
                <td>
                  <strong *ngIf="k.tasaActivacion !== null">{{ k.tasaActivacion }}%</strong>
                  <span class="dim" *ngIf="k.tasaActivacion === null">sin datos</span>
                </td>
                <td>
                  <span *ngIf="k.costoPorPrimerEnvio">
                    {{ legible(k.costoPorPrimerEnvio) }} <span class="mono">{{ k.moneda }}</span>
                  </span>
                  <span class="dim" *ngIf="!k.costoPorPrimerEnvio">&mdash;</span>
                </td>
                <td>{{ k.reactivados }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- El interruptor del módulo y los techos de gasto.
       Escribe en `parametros`: cada cambio queda en el log con el correo del
       operador y avisa al canal de Telegram. -->
  <div class="badm-overlay" *ngIf="mostrarConfig && editable" (click)="cerrarConfig()">
    <div class="badm-modal" (click)="$event.stopPropagation()">
      <h2>Configuraci&oacute;n del m&oacute;dulo</h2>

      <label class="badm-toggle">
        <input type="checkbox" [(ngModel)]="editable.activo" />
        <span>
          <b>{{ editable.activo ? 'M&oacute;dulo encendido' : 'M&oacute;dulo apagado' }}</b>
          <small>
            Apagado no se acepta ning&uacute;n reclamo y los jobs no acreditan nada. Los
            operadores igual pueden armar y programar campa&ntilde;as.
          </small>
        </span>
      </label>

      <p class="badm-aviso" *ngIf="vaAApagar">
        Apagar frena los pagos ya. Los bonos <b>retenidos no se pierden</b>: quedan
        esperando y se acreditan cuando el m&oacute;dulo vuelva, si todav&iacute;a est&aacute;n
        en fecha.
      </p>

      <!-- Los techos del mes. Uno por moneda, porque un techo consolidado en
           dólares se mueve con la tasa y autorizaría un gasto distinto cada día. -->
      <span class="badm-titulo">Techo de gasto del mes</span>
      <small class="badm-pista">
        <b>En 0 no se paga nada en esa moneda.</b> Es a prop&oacute;sito: un control de
        gasto ausente frena en vez de dejar pasar. Va por moneda y no consolidado en
        d&oacute;lares &mdash; un techo en d&oacute;lares se mueve con la tasa y
        autorizar&iacute;a un gasto distinto cada d&iacute;a.
      </small>
      <div class="badm-grid">
        <label *ngFor="let m of monedasConTecho">
          <span>{{ m }}</span>
          <input type="number" min="0" [(ngModel)]="editable.topeMensual[m]" />
          <small>
            M&aacute;ximo a pagar en {{ m }} este mes, sumando todas las campa&ntilde;as.
            Alcanzado, los bonos quedan retenidos hasta el mes que viene.
          </small>
        </label>
      </div>

      <span class="badm-titulo">Freno de ritmo</span>
      <small class="badm-pista">
        Cu&aacute;ntos intentos se aceptan por ventana. Es el chequeo 00, el m&aacute;s
        barato: corre antes que todo lo dem&aacute;s para que un bot no pague las
        consultas de los otros doce.
      </small>
      <div class="badm-grid">
        <label>
          <span>Intentos por IP</span>
          <input type="number" min="1" max="1000" [(ngModel)]="editable.ritmoIpMax" />
          <small>
            Cu&aacute;ntos c&oacute;digos puede probar una misma conexi&oacute;n antes de
            que se le frene. Contiene al que prueba c&oacute;digos al voleo.
          </small>
        </label>
        <label>
          <span>Ventana de la IP</span>
          <input type="number" min="1" max="1440" [(ngModel)]="editable.ritmoIpMinutos" />
          <small>Minutos que dura ese conteo. Pasados, vuelve a cero.</small>
        </label>
        <label>
          <span>Intentos por documento</span>
          <input type="number" min="1" max="1000" [(ngModel)]="editable.ritmoDocMax" />
          <small>
            Lo mismo por persona. Va por documento y no por cuenta: crear diez
            correos es gratis, tener diez documentos no.
          </small>
        </label>
        <label>
          <span>Ventana del documento</span>
          <input type="number" min="1" max="1440" [(ngModel)]="editable.ritmoDocMinutos" />
          <small>Minutos que dura ese conteo.</small>
        </label>
      </div>

      <span class="badm-titulo">Defaults de campa&ntilde;a</span>
      <div class="badm-grid">
        <label>
          <span>Pausa autom&aacute;tica</span>
          <input type="number" min="1" max="100" [(ngModel)]="editable.pausaPct" />
          <small>
            Si en la ventana se reclama m&aacute;s de este <b>% del cupo</b>, la
            campa&ntilde;a se pausa sola y avisa. Se cuenta sobre bonos tomados, no
            sobre intentos.
          </small>
        </label>
        <label>
          <span>en</span>
          <input type="number" min="1" max="1440" [(ngModel)]="editable.pausaMinutos" />
          <small>Los minutos de esa ventana.</small>
        </label>
        <label>
          <span>Inactividad</span>
          <input type="number" min="1" max="3650" [(ngModel)]="editable.inactivoDias" />
          <small>
            Cu&aacute;ntos d&iacute;as sin enviar hacen que alguien cuente como inactivo.
            Es el valor que propone el formulario de campa&ntilde;a.
          </small>
        </label>
        <label>
          <span>Retenci&oacute;n de intentos</span>
          <input type="number" min="1" max="3650" [(ngModel)]="editable.intentoRetencionDias" />
          <small>
            Cu&aacute;nto se guarda el registro de qui&eacute;n intent&oacute; reclamar.
            Es lo que permite ver un ataque despu&eacute;s; con menos d&iacute;as, menos
            historia.
          </small>
        </label>
      </div>

      <span class="badm-titulo">Carga m&iacute;nima para destrabar un bono</span>
      <small class="badm-pista">
        S&oacute;lo para campa&ntilde;as con condici&oacute;n <b>al cargar saldo</b>. Son
        los pisos de bonos y no los de referidos: cu&aacute;nto hay que cargar para que el
        bono se destrabe es una decisi&oacute;n de cada programa.
      </small>
      <div class="badm-grid">
        <label>
          <span>CLP</span>
          <input type="number" min="1" [(ngModel)]="editable.fondeoMinClp" />
          <small>Cu&aacute;nto tiene que cargar en pesos para destrabar el bono.</small>
        </label>
        <label>
          <span>VES</span>
          <input type="number" min="1" [(ngModel)]="editable.fondeoMinVes" />
          <small>Lo mismo en bol&iacute;vares. Conviene revisarlo con la tasa.</small>
        </label>
        <label>
          <span>USDT</span>
          <input type="number" min="1" [(ngModel)]="editable.fondeoMinUsdt" />
          <small>Lo mismo en USDT.</small>
        </label>
      </div>

      <span class="badm-titulo">Doble control: desde qu&eacute; bolsa</span>
      <small class="badm-pista">
        Desde ese monto, activar una campa&ntilde;a necesita <b>un segundo operador</b>:
        quien la crea no la activa. Va por moneda porque comparar una bolsa en
        d&oacute;lares contra un umbral en pesos no quiere decir nada.
        <b>En 0 lo necesitan todas</b> &mdash; no es &laquo;apagado&raquo;, es
        &laquo;siempre&raquo;. Subirlo debilita el control y queda registrado con tu
        correo.
      </small>
      <div class="badm-grid">
        <label *ngFor="let m of monedasConUmbral">
          <span>{{ m }}</span>
          <input type="number" min="0" [(ngModel)]="editable.dobleControl[m]" />
          <small>
            Una campa&ntilde;a en {{ m }} con bolsa <b>igual o mayor</b> a este monto
            necesita que la active otra persona.
          </small>
        </label>
      </div>

      <div class="badm-modal-acciones">
        <button
          class="badm-guardar"
          [disabled]="!hayCambiosConfig || guardandoConfig"
          (click)="guardarConfig()"
        >
          {{ guardandoConfig ? 'Guardando…' : 'Guardar' }}
        </button>
        <button class="badm-cancelar" (click)="cerrarConfig()">Cancelar</button>
      </div>
    </div>
  </div>

  <!-- El formulario de campaña, como modal sobre la lista. -->
  <app-crear-campana-modal
    *ngIf="mostrarNueva"
    (creada)="creada($event)"
    (cancelar)="cerrarNueva()"
  ></app-crear-campana-modal>
</div>
